<script lang="ts" setup>
import VerticalNavSectionTitle from '@/@layouts/components/VerticalNavSectionTitle.vue'
import VerticalNavGroup from '@layouts/components/VerticalNavGroup.vue'
import VerticalNavLink from '@layouts/components/VerticalNavLink.vue'

const { $auth } = useNuxtApp()
</script>

<template>
  <!-- 👉 Dashboards -->
  <!--
    <VerticalNavGroup
    :item="{
    title: 'Dashboards',
    badgeContent: '5',
    badgeClass: 'bg-error',
    icon: 'ri-home-smile-line',
    }"
    >
    <VerticalNavLink
    :item="{
    title: 'Analytics',
    to: '/dashboard',
    }"
    />
    </VerticalNavGroup>
  -->

  <!-- 👉 Apps & Pages -->

  <VerticalNavLink
    :item="{
      title: 'Tradeview Signals',
      icon: 'ri-admin-line',
      to: '/signals',
    }"
  />

  <VerticalNavSectionTitle
    :item="{
      heading: 'Token Management',
    }"
  />

  <VerticalNavLink
    :item="{
      title: 'Token API',
      icon: 'ri-coin-line',
      to: '/manage-tokens',
    }"
  />

  <VerticalNavLink
    :item="{
      title: 'Cấu hình',
      icon: 'ri-settings-4-line',
      to: '/configs',
    }"
  />

  <VerticalNavSectionTitle
    :item="{
      heading: 'Others',
    }"
  />

  <VerticalNavGroup
    :item="{
      title: 'User',
      icon: 'ri-user-3-line',
    }"
  >
    <VerticalNavLink
      :item="{
        title: 'User Profile',
        icon: 'ri-user-settings-line',
        to: '/profile',
      }"
    />
  </VerticalNavGroup>

  <template v-if="$auth.isAdmin.value">
    <VerticalNavSectionTitle
      :item="{
        heading: 'Admin Only',
      }"
    />
    <VerticalNavGroup
      :item="{
        title: 'BingX',
        icon: 'ri-admin-line',
      }"
    >
      <VerticalNavLink
        :item="{
          title: 'Playground',
          icon: 'ri-play-circle-line',
          to: '/playground',
        }"
      />
    </VerticalNavGroup>
    <VerticalNavLink
      :item="{
        title: 'System settings',
        icon: 'ri-settings-3-fill',
        to: '/system-settings',
      }"
    />
  </template>

  <!--
    <VerticalNavLink
    :item="{
    title: 'Login',
    icon: 'ri-login-box-line',
    to: '/login',
    }"
    />
    <VerticalNavLink
    :item="{
    title: 'Register',
    icon: 'ri-user-add-line',
    to: '/register',
    }"
    />
  -->

  <!-- 👉 User Interface -->
  <!--
    <VerticalNavSectionTitle
    :item="{
    heading: 'User Interface',
    }"
    />
    <VerticalNavLink
    :item="{
    title: 'Typography',
    icon: 'ri-text',
    to: '/typography',
    }"
    />
    <VerticalNavLink
    :item="{
    title: 'Icons',
    icon: 'ri-remixicon-line',
    to: '/icons',
    }"
    />
    <VerticalNavLink
    :item="{
    title: 'Cards',
    icon: 'ri-bar-chart-box-line',
    to: '/cards',
    }"
    />
  -->

  <!-- 👉 Forms & Tables -->
  <!--
    <VerticalNavSectionTitle
    :item="{
    heading: 'Forms & Tables',
    }"
    />
    <VerticalNavLink
    :item="{
    title: 'Form Layouts',
    icon: 'ri-layout-4-line',
    to: '/form-layouts',
    }"
    />
    <VerticalNavLink
    :item="{
    title: 'Tables',
    icon: 'ri-table-alt-line',
    to: '/tables',
    }"
    />
  -->
</template>
